const events = {
    LAYOUT_trySubscribeWithAuth: 'trySubscribeWithAuth.kiosk.LAYOUT',
    LAYOUT_trySubscribeWithoutAuth: 'trySubscribeWithoutAuth.kiosk.LAYOUT',

    ARTICLE_trySubscribeWithAuth: 'trySubscribeWithAuth.kiosk.ARTICLE',

    ARTICLE_tryAuth: 'tryAuth.kiosk.ARTICLE',
    ARTICLE_tryAuthVk: 'tryAuthVk.kiosk.ARTICLE',
    ARTICLE_tryAuthGp: 'tryAuthGp.kiosk.ARTICLE',
    ARTICLE_tryAuthFb: 'tryAuthFb.kiosk.ARTICLE',

    LAYOUT_tryAuth: 'tryAuth.kiosk.LAYOUT',
    LAYOUT_bookmarks: 'bookmarks.kiosk.LAYOUT',
    LAYOUT_profile: 'profile.kiosk.LAYOUT',
    LAYOUT_magazines: 'magazines.kiosk.LAYOUT',
    LAYOUT_audio: 'audio.kiosk.LAYOUT',
    LAYOUT_appIos: 'appIos.kiosk.LAYOUT',
    LAYOUT_appAndroid: 'appAndroid.kiosk.LAYOUT',

    AUTH_MODAL_tryAuthVk: 'tryAuthVk.kiosk.AUTH_MODAL',
    AUTH_MODAL_tryAuthGp: 'tryAuthGp.kiosk.AUTH_MODAL',
    AUTH_MODAL_tryAuthFb: 'tryAuthFb.kiosk.AUTH_MODAL',
    AUTH_MODAL_tryAuthMobileConnect: 'tryAuthMobileConnect.kiosk.AUTH_MODAL',

    //---------------------------------------//
    AUTH_MODAL_show: 'show.kiosk.AUTH_MODAL',
    AUTH_MODAL_submitLogin: 'submitLogin.kiosk.AUTH_MODAL',
    /** Отправка номера телефона  (открытие окна) **/
    AUTH_MODAL_submitPhone: 'submitPhone.kiosk.AUTH_MODAL',
    /** Ввод номера телефона и нажатие кнопки “Запросить код” **/

    AUTH_MODAL_submitPhoneSuccess: 'submitPhoneSuccess.kiosk.AUTH_MODAL',
    /** Ввод номера телефона и нажатие кнопки “Запросить код”  (открытие второго окна)  **/
    AUTH_MODAL_submitPhoneFail: 'submitPhoneFail.kiosk.AUTH_MODAL',
    /** Ошибки при вводе номера телефона **/

    AUTH_MODAL_submitCode: 'submitCode.kiosk.AUTH_MODAL',
    /** Ввод кода из смс и нажатие кнопки Продолжить / Авторизоваться **/
    AUTH_MODAL_submitCodeSuccess: 'submitCodeSuccess.kiosk.AUTH_MODAL',
    /** Успешный ввод кода из смс **/
    AUTH_MODAL_submitCodeFail: 'submitCodeFail.kiosk.AUTH_MODAL',         /** Ошибки ввода кода из смс **/

    /**  */
    AUTH_success: 'authSuccess.kiosk.AUTH',
    REGISTRATION_success: 'registrationSuccess.kiosk.AUTH',

    DOWNLOAD_APP_MODAL_tryIos: 'tryIos.kiosk.DOWNLOAD_APP_MODAL',
    DOWNLOAD_APP_MODAL_tryAndroid: 'tryAndroid.kiosk.DOWNLOAD_APP_MODAL',

};

export {events}
